import { ApiResponse } from '@/types/api'
import { httpClient } from './http-client'

export class __cRedisService {
  static async getByApi<T>(key: string) {
    try {
      const response = await httpClient.V4_NEW.get<ApiResponse<string>>(
        `/redis/get-by-key/${key}`
      )
      return response.data ? (response.data as T) : null
    } catch (error) {
      console.error('Failed to fetch redis data:', error)
      return null
    }
  }
}
